<script>
    import {createEventDispatcher} from "svelte";
    import {fade, fly} from "svelte/transition";
    import Fa from 'svelte-fa'
    import { faAngleLeft, faXmark } from '@fortawesome/free-solid-svg-icons'
    import TileGroup from "./TileGroup.svelte";
    import { oldTestamentBooks, newTestamentBooks } from "../constants/bibleBooks";

    export let showChapters = false
    export let selectedBook

    const dispatch = createEventDispatcher()

    const clearSelections = () => {
        dispatch('clearSelections')
    }

    const closeSelectionModal = () => {
        dispatch('closeSelectionModal')
    }

    const handleChapterSelect = (e) => {
        dispatch('handleChapterSelect', e.detail)
    }

    const handleSelectTile = (e) => {
        dispatch('handleSelectTile', e.detail)
    }

    const toChapters = (num) => {
        return Array.from(Array(num).keys()).map(item => {
            return {
                chapter: item + 1
            }
        })
    }
</script>


<div transition:fade class="flex justify-center">
    <div class="absolute sm:w-2/3 md:w-1/2 w-11/12 z-10 border-2 border-blue-300 p-4 rounded-2xl bg-blue-50">
        {#if showChapters}
            <div class="flex justify-between">
                <span on:click={clearSelections} class="cursor-pointer">
                    <Fa icon={faAngleLeft} size="lg" color="#444"/>
                </span>
                <p class="text-xl text-center text-gray-700 flex justify-between">
                    {selectedBook.label}
                </p>
                <span on:click={closeSelectionModal} class="cursor-pointer">
                    <Fa icon={faXmark} size="lg"/>
                </span>
            </div>
            <TileGroup on:selectTile={handleChapterSelect} list={toChapters(selectedBook.chapters)} property="chapter"/>
        {:else}
            <div class="flex justify-between">
                <div></div>
                <p class="text-2xl text-center text-gray-700 font-bold justify-between">Old Testament
                </p>
                <span on:click={closeSelectionModal} class="scale_icon cursor-pointer">
                            <Fa icon={faXmark} size="lg"/>
                        </span>
            </div>
            <TileGroup on:selectTile={handleSelectTile} list={oldTestamentBooks} property="abbrv"/>
            <p class="text-2xl text-center text-gray-700 font-bold pt-4">New Testament</p>
            <TileGroup on:selectTile={handleSelectTile} list={newTestamentBooks} property="abbrv"/>
        {/if}
    </div>
</div>